import React from "react";

function MacAppDownload({ isDownloading, error, onDownload }) {
  return (
    <div>
      <button
        type="button"
        className="button button-secondary"
        onClick={onDownload}
        disabled={isDownloading}
      >
        {isDownloading ? "Downloading Developer AI…" : "Download for Mac"}
      </button>
      {error && <p role="alert" style={{ color: "#b42318", margin: "8px 0 0", fontSize: "0.9rem" }}>{error}</p>}
    </div>
  );
}

export default MacAppDownload;
